import apiService from "./api";

export interface WisdomQuote {
	text: string;
	author: string;
}

export interface WisdomQuoteRecord extends WisdomQuote {
	id: string;
	isActive: boolean;
	createdAt: string;
	updatedAt: string;
}

export const wisdomQuoteService = {
	getRandomQuote(lang: string): Promise<WisdomQuote> {
		return apiService.get("/wisdom-quotes/random", { params: { lang } });
	},

	findAll(search?: string): Promise<WisdomQuoteRecord[]> {
		return apiService.get("/wisdom-quotes", { params: { search } });
	},

	create(data: { text: string; author: string }): Promise<WisdomQuoteRecord> {
		return apiService.post("/wisdom-quotes", data);
	},

	update(id: string, data: Partial<{ text: string; author: string; isActive: boolean }>): Promise<WisdomQuoteRecord> {
		return apiService.patch(`/wisdom-quotes/${id}`, data);
	},

	remove(id: string): Promise<void> {
		return apiService.delete(`/wisdom-quotes/${id}`);
	},
};

export default wisdomQuoteService;
